import Queue from './queue';
import Present from './present';
import Event from './eventBus';

import verticalPresent from './verticalPresent/verticalPresent';
// import verticalEffect from './verticalEffect/verticalEffect';
import horizontalPresent from './horizontalPresent/horizontalPresent';
// import horizontalEffect from './horizontalEffect/horizontalEffect';
import effect from './effect/effect';
import goldEgg from './goldEgg/goldEgg';
// import horizontalEffect from './horizontalEffect';
// console.log(verticalPresent)

class PresentUI{
    constructor({message, clientOptions, presentInfo = [], queue_config = {}, present_config = {}, effect_config = {}, goldEgg_config = {}, orientation = 'vertical'}) {
        this.message = message;
        this.clientOptions = clientOptions;

        this.presentInfo = presentInfo;
        this.queue_config = queue_config;
        this.present_config = present_config;
        this.effect_config = effect_config;
        this.goldEgg_config = goldEgg_config;

        this.presentDatas = {};
        this.presentFactory = {};
        this.orientation = orientation;
        this.event = Event;

        if(!this.presentInfo.length) {
            console.log('礼物信息错误')
            return;
        } else {
            this.init();
            this.initCustomEvent();
        }
    }

    init() {
        this.queue = new Queue(this.queue_config);
        this.present = new Present(this.present_config, this.message);

        this.factory = {
            present:{
                vertical: new verticalPresent(this.presentInfo, this.clientOptions),
                horizontal: new horizontalPresent(this.presentInfo, this.clientOptions)
            },
            effect: new effect(this.presentInfo),
            goldEgg: new goldEgg({orientation:this.orientation})
        }


    }

    initCustomEvent() {
        this.event.on('receive-presentDatas', this.notifyReceivePresentDatas.bind(this));
        this.present
        .isLogin()
        .then((type) => this.event.trigger('isLogin', type))

    }

    notifyReceivePresentDatas(datas) {

        var _this = this;
        if(this.presentDatas && this.queue.remainQueueLength > 0) {

            let _fun = () => {
                return _this.runTask(datas[0]).catch((err) => console.log(err));
            }

            this.queue.add(_fun);
        }
    }

    runTask(data) {
        var _this = this;
        if(data && data.comboid) {
            return this.dispatchTask(data)
                .then(({newData, oldData}) => {
                    _this.present.removePresentData(newData);

                }).then(() => {
                    if(_this.present.getPresentDatas()[0]) {
                        return _this.runTask(_this.present.getPresentDatas()[0])
                    }
                })
        }
    }

    dispatchTask(newData) {
        // 1.开始运行动画
        // 2.运行之后查询是否还有连击
        // 3.有连击继续运行
        // 4.没有就查询当前presentDatas是否还有排队
        // 5.没有就获取新的数据
        var _this = this;
        return new Promise((resolve, reject) => {
            let new_comboId = newData.comboid;
            let oldData = this.presentDatas[new_comboId];

            // 如果传来的数据没有comboid，认为数据错误，直接reject
            if(!new_comboId) {
                reject('数据错误');
            }

            // 如果当前comboid第一次运行或老数据comboid不存在，则直接开始动画效果
            if(!oldData || !oldData.comboid) {
                // console.log(4444)
                this.presentDatas[new_comboId] = newData;
                return this.startAnimate(newData)
                    .then(({newData, oldData}) => {
                        _this.presentDatas[new_comboId] = newData;
                        resolve({newData, oldData})
                    });
            }

            // 如果老数据存在，且新数据combo数大于老数据combo数
            if(parseInt(newData.combo) > parseInt(oldData.combo)) {
                // console.log(5555)
                this.presentDatas[new_comboId] = newData;
                return this.startAnimate(newData, oldData)
                    .then(({newData, oldData}) => {
                        _this.presentDatas[new_comboId] = newData;
                        resolve({newData, oldData})
                    });
            } else {
                resolve(oldData);
            }

        })
    }

    startAnimate(newData, oldData) {
        let _effect = this.factory.effect;

        if(!_effect) {
            return ;
        }

        let _iteratorProcess = ({newData, oldData}) => {
            let _isExistComboData = this.present.getPresentDataByComboid(newData.comboid);
            if(parseInt(_isExistComboData.combo) > parseInt(newData.combo)) {
                console.log(888888)
                return _effect.process.bind(_effect)({newData: _isExistComboData, oldData:newData})
                    .then(_iteratorProcess)
            } else {
                //删除当前已动画完数据
                return {newData};
            }
        }
        return Promise.resolve({newData, oldData})
            .then(_effect.start.bind(_effect))
            .then(_effect.enter.bind(_effect))
            // .then(({newData, oldData}) => {
            //     return new Promise(resolve => {
            //         setTimeout(() => resolve({newData, oldData}), 300000)
            //     })
            // })
            .then(_effect.process.bind(_effect))
            .then(_iteratorProcess)
            .then(_effect.leave.bind(_effect))
            .then(_effect.end.bind(_effect))
            .then(({newData, oldData}) => {
                // console.log(newData,oldData)

                return {newData, oldData}
            })
    }

    switchOrientation(orientation) {
        if(orientation == 'horizontal'){
            this.orientation = 'horizontal';
        } else if(orientation == 'vertical') {
            this.orientation = 'vertical';
        }

        this.event.trigger('orientation', orientation);
    }
    updateCoin(value, orientation = this.orientation) {
        if(this.factory.present[orientation]) {
            this.factory.present[orientation].updateCoin(value);
        }
    }
    enter(orientation = this.orientation) {
        if(this.factory.present[orientation]) {
            this.factory.present[orientation].enter();
        }
    }


    leave(orientation = this.orientation) {
        if(this.factory.present[orientation]) {
            this.factory.present[orientation].leave();
        }
    }

    hide(orientation = this.orientation) {
        if(this.factory.present[orientation]) {
            this.factory.present[orientation].hide();
        }
    }

    setVerticalEffectTop(top) {
        this.factory.effect.setVerticalEffectTop(top);
    }

}

export default PresentUI;





// WEBPACK FOOTER //
// /Users/gebb/Desktop/live/modules/f.component.gift.mobile/app/lib/ui.js